var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send_Gift_icon_64x64",
    "data-name": "Send Gift icon 64x64",
    transform: "translate(-327 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_64x64",
    "data-name": "64x64",
    width: 64,
    height: 64,
    transform: "translate(327 361)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gift_icon",
    "data-name": "gift icon",
    transform: "translate(339 373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M36,12V32H4V12",
    transform: "translate(0 8)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M2,7H42V17H2Z",
    transform: "translate(-2 3)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M12,37V7",
    transform: "translate(8 3)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M19,12H10A5,5,0,0,1,10,2C17,2,19,12,19,12Z",
    transform: "translate(1 -2)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M12,12h9A5,5,0,0,0,21,2C14,2,12,12,12,12Z",
    transform: "translate(8 -2)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "send_icon",
    "data-name": "send icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(363 397)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(366 401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M17.6,2,11,8.6",
    transform: "translate(-3.6 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M14,2,9.8,14,7.4,8.6,2,6.2Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGiftIcon);
export default __webpack_public_path__ + "static/media/SendGiftIcon.3b10ca2094f6733801f282489ffa721b.svg";
export { ForwardRef as ReactComponent };